import { createSlice } from '@reduxjs/toolkit'
import { apiSlice } from './api/apiSlice'

const initialState = {
  data: {
    mortgageId: null,
    monthlyPayments: null,
    principalRemaining: null,
    interestRemaining: null,
    remainingTerm: null,
    originalLoanAmount: null,
    originalInterestDue: null,
  },
  status: 'idle',
  error: null
}

export const viewingMortgageFinancialsSlice = createSlice({
  name: 'viewingMortgageFinancials',
  initialState,
  reducers: {
    setViewingMortgageFinancials(state, action) {
      state.data = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
    .addMatcher(apiSlice.endpoints.addPrincipalOnlyPayment.matchFulfilled, (state, {payload}) => {
      if (payload.data && payload.data.newMortgage) {
        state.data = {
          mortgageId: payload.data.newMortgage._id,
          monthlyPayments: payload.data.newMortgage.monthlyPayments,
          principalRemaining: payload.data.newMortgage.principalRemaining,
          interestRemaining: payload.data.newMortgage.interestRemaining,
          remainingTerm: payload.data.newMortgage.remainingTerm,
          originalLoanAmount: payload.data.newMortgage.originalLoanAmount,
          originalInterestDue: payload.data.newMortgage.originalInterestDue,
        }
      }
    })
  },
})

export const { setViewingMortgageFinancials } = viewingMortgageFinancialsSlice.actions

export default viewingMortgageFinancialsSlice.reducer

export const selectViewingMortgageFinancials = state => state.viewingMortgageFinancials.data
